import script from "./ModalBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBox.vue?vue&type=script&setup=true&lang=js"

import "./ModalBox.vue?vue&type=style&index=0&id=26d8bed5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d8bed5"]])

export default __exports__